module.exports = __webpack_public_path__ + "static/media/speakers_logos_POLYU.210b2c79.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/conf/speaker/speakers_logos_POLYU.jpg
// module id = 269
// module chunks = 0